// Paso 3 "Mi carrera" del formulario de inscripción rediseñado (v2), solo pregrado regular.
// Mismas props (props_c) que InscripcionAgregarMiCarerra. El documento de los padres se carga con
// CampoArchivo, que entrega el archivo al contenedor (setArchivo); ya no hay input oculto.
import React from "react";
import Grid from "@material-ui/core/Grid";
import SchoolIcon from "@material-ui/icons/School";
import ForumIcon from "@material-ui/icons/Forum";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import BuscarSelect from "../../general/BuscarSelect";
import { useEstilosInscripcion } from "./estilosInscripcion";
import { Seccion, Nota, columnas, CampoArchivo } from "./componentesInscripcion";

const CODIGO_PSICOLOGIA = "14011";

export default function PasoMiCarrera({ props_c }) {
  const classes = useEstilosInscripcion();
  let {
    carrerassedes, sede, sedes, mostrar_carreras, setOpcion_sedes, opciones_conociste, opcion_conociste,
    setOpcion_conociste, carrera, setCarrera, adj_idpadres, adj_idpadres_final, setArchivo, menor_edad, link_consentimiento_informado,
    campo_error,
  } = props_c;

  // Campo marcado en rojo tras "Enviar inscripción" (campo_error lo define validarDatos en InscripcionAgregar)
  const err = (campo) => campo_error === campo;
  const marca = (campo) => (err(campo) ? { "data-error": "true" } : {});
  const claseSelect = (campo) => `${classes.campoSelect} ${err(campo) ? classes.campoSelectError : ""}`;

  const pideDocumentoPadres = menor_edad && carrera.codigo == CODIGO_PSICOLOGIA;

  return (
    <React.Fragment>

      <p className={classes.tituloPaso}>¿Qué quieres estudiar?</p>
      <p className={classes.descripcionPaso}>Los campos con * son obligatorios.</p>

      <Seccion icono={SchoolIcon} titulo="Programa de interés">
        <Grid item {...marca("sede")} {...columnas(0, 2)}>
          <div className={claseSelect("sede")}><BuscarSelect datos={sedes} cambiarEstado={(value) => setOpcion_sedes(value)} valor={sede} id="select-sedes" nombre="Sede" placeholder="Seleccione sede" /></div>
        </Grid>
        <Grid item {...marca("carrera")} {...columnas(1, 2)}>
          <div className={claseSelect("carrera")}><BuscarSelect datos={carrerassedes} cambiarEstado={(value) => setCarrera(value)} valor={carrera} id="select-carrera" nombre="Programa" placeholder={mostrar_carreras ? "Seleccione programa" : "Cargando información, por favor espere..."} habilitado={mostrar_carreras ? true : false} /></div>
        </Grid>
      </Seccion>

      {pideDocumentoPadres && (
        <Seccion icono={SupervisorAccountIcon} titulo="Autorización de los padres">
          <Grid item xs={12} {...marca("adj_idpadres")}>
            <CampoArchivo id="archivo-adj_idpadres" label="Identificación de los padres" required nombre={adj_idpadres} archivo={adj_idpadres_final} onCambiar={(f) => setArchivo("adj_idpadres", f)} error={err("adj_idpadres")} />
          </Grid>
          <Grid item xs={12} style={{ paddingTop: 0 }}>
            <Nota>
              Como eres menor de edad y elegiste Psicología, adjunta la identificación de tus padres en aprobación al{" "}
              <a href={link_consentimiento_informado} target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "underline" }}>consentimiento informado</a>.
            </Nota>
          </Grid>
        </Seccion>
      )}

      <Seccion icono={ForumIcon} titulo="¿Cómo nos conociste?">
        <Grid item {...marca("opcion_conociste")} {...columnas(0, 1)}>
          <div className={claseSelect("opcion_conociste")}><BuscarSelect datos={opciones_conociste} cambiarEstado={(value) => setOpcion_conociste(value)} valor={opcion_conociste} id="select-tipo-conociste" nombre="Medio por el que nos conociste" placeholder="Seleccione opción" /></div>
        </Grid>
      </Seccion>

    </React.Fragment>
  );
}
